import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';

interface ActionButtonsFormikProps {
  disabled?: boolean;
  totalSteps?: number;
}

const ActionButtonsFormik: React.FC<
  ActionButtonsFormikProps
> = ({ disabled, totalSteps = 8 }) => {
  const { formulario, setPartialForm, salvarRascunho, enviarAprovacao } =
    useFormularioSecretariaMunicipalAgriculturaStore();
  const stepAtual: any = formulario?.step_atual;
  const navigate = useNavigate();

  const handleSalvarRascunho = async () => {
    const response = await salvarRascunho();
    if (response) {
      alert('Rascunho salvo com sucesso');
      navigate('/pacote-de-formularios');
    } else {
      alert('Erro ao salvar rascunho');
    }
  };

  const handleVoltar = () => {
    setPartialForm('step_atual', stepAtual - 1);
  };

  return (
    <Box
      display={'flex'}
      justifyContent={'flex-end'}
      gap={2}
      mt={4}
      width={'100%'}
    >
      {/* voltar um formulario */}
      {stepAtual > 1 && (
        <Button variant='outlined' color='primary' onClick={handleVoltar}>
          Voltar
        </Button>
      )}
      <Button
        variant='contained'
        color='primary'
        type='submit'
      >
        Salvar como rascunho
      </Button>
      {formulario?.step_atual === totalSteps ? (
        <Button variant='outlined' color='primary'
          type='submit'
          disabled={disabled}
        >
          Enviar para aprovação
        </Button>
      ) : (
        <Button
          variant='contained'
          color='primary'
          type='submit'
          disabled={disabled}
        >
          Avançar
        </Button>
      )}
    </Box>
  );
};

export default ActionButtonsFormik;
